import {ApprovalStatus, PayType} from '$share/constants/card'
import {MdCard, MyDataCard, NfCard, UniCardCommon} from '$share/types/card/common'
import {CommonDate, DetailDate} from '$share/types/common'

type PurchaseCancel = Readonly<{
    purchaseNum: string // 매입번호
    purchaseDate: CommonDate // 매입일자
    salesDate: CommonDate | null //  매출일자
    approvedAmt: number // 이용금액
    currencyCode: string // 매입시 통화코드
    krwAmt: number // 이용금액 원화
}>

export type Approval = Readonly<{
    id: number // CardApproval ID
    card: Pick<MyDataCard, 'id' | 'org' | 'name' | 'nickname' | 'num' | 'seqno' | 'imageUrl'>
    approvedNum: string | null // 승인번호, 승인내역과 매핑되지 않은 매입취소인 경우 null
    status: ApprovalStatus | null // 카드 결제 상태, 승인내역과 매핑되지 않은 매입취소인 경우 null
    payType: PayType // 카드 사용 구분
    transAt: string | null // (nullable) 취소일지 or 정정일시
    approvedAmt: number // 승인금액, 승인내역과 매핑되지 않은 매입취소인 경우 매입 취소정보의 이용금액
    approvedAt: string // 승인일시
    modifiedAmt: number | null // (nullable) 정정후 금액
    krwAmt: number | null // 원화환산금액. 외화승인 중이거나, 승인내역과 매핑되지 않은 매입취소인 경우 null
    merchantName: string | null // (nullable) 가맹점명
    merchantRegno: string | null // (nullable) 가맹점사업자등록번호
    totalInstallCnt: number | null // (nullable) 전체할부회차
    countryCode: string | null // 사용국가코드
    countryName: string | null // 사용국가명
    currencyCode: string // 통화코드(ex: KRW)
    merged: boolean // 취소, 정정거래의 경우 원승인거래와 매핑 여부
    purchCancels: PurchaseCancel[] | null // 매입취소건인 경우 매입취소정보 목록
    finalAmt: number | null // 매입 취소가 된 경우 매입후최종금액. 원승인 정보가 있으면 승인금액 - 매입취소금액, 원승인 정보가 있으면 0
    createAt: string // 생성시각
    updateAt: string // 수정시각
    title: string | null // 노출 타이틀
}>

export interface UniMyDataCardSummary extends UniCardCommon {
    mdCard: Pick<
        MdCard,
        'id' | 'org' | 'seqno' | 'status' | 'type' | 'consent' | 'issueDate' | 'createAt' | 'updateAt'
    > & {monthlyRecord: number | null}
}

export interface UniPrepaidCardSummary extends UniCardCommon {
    nfCard: NfCard
}

export type UniCardSummary = UniMyDataCardSummary | UniPrepaidCardSummary

export const isUniMyDataCardSummary = (uniCardSummary: UniCardSummary): uniCardSummary is UniMyDataCardSummary => {
    return 'mdCard' in uniCardSummary && uniCardSummary.mdCard !== null
}

export const isUniPrepaidCardSummary = (uniCardSummary: UniCardSummary): uniCardSummary is UniPrepaidCardSummary => {
    return 'nfCard' in uniCardSummary && uniCardSummary.nfCard !== null
}

export interface MyDataCardUsageAmt {
    uniCard: UniMyDataCardSummary
    amt: number
    amtMoM: null | number
}

export interface PrepaidCardUsageAmt {
    uniCard: UniPrepaidCardSummary
    amt: number
    amtMoM: null | number
}

export type UsageAmt = MyDataCardUsageAmt | PrepaidCardUsageAmt

export const isMyDataCardUsageAmt = (usageAmt: UsageAmt): usageAmt is MyDataCardUsageAmt => {
    return isUniMyDataCardSummary(usageAmt.uniCard)
}

export const isPrepaidCardUsageAmt = (usageAmt: UsageAmt): usageAmt is PrepaidCardUsageAmt => {
    return isUniPrepaidCardSummary(usageAmt.uniCard)
}
export interface CardSummary {
    totalAmt: number // 요청월 전체카드 사용금액 합계 (takeCnt 와 상관없이 모든카드의 사용금액)
    usageAmtList: UsageAmt[]
    totalAmtMoM: number | null // 요청월이 이번달이면 지난달 동기일까지의 사용금액 합계
    totalPayAmt: number | null // 요청월이 이번달이면 결제예정금액 합계
}

export interface ApprovalGoal {
    recordAmt: number
    notification: boolean
    notiDay: number
    createAt: DetailDate
    updateAt: DetailDate
}
